import React from 'react';

import AdminPanel from '../../../../assets/icons/ReactSvg/AdminPanel';
import '../Landing.css';

import { Grid } from '@material-ui/core';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import testimonialsSection from '../testimonialsStyle';
import userStyles from '../styles/usersStyle';

const hexToRgb = (input) => {
  input = input + '';
  input = input.replace('#', '');
  let hexRegex = /[0-9A-Fa-f]/g;
  if (!hexRegex.test(input) || (input.length !== 3 && input.length !== 6)) {
    throw new Error('input is not a valid hex color.');
  }
  if (input.length === 3) {
    let first = input[0];
    let second = input[1];
    let last = input[2];
    input = first + first + second + second + last + last;
  }
  input = input.toUpperCase(input);
  let first = input[0] + input[1];
  let second = input[2] + input[3];
  let last = input[4] + input[5];
  return parseInt(first, 16) + ', ' + parseInt(second, 16) + ', ' + parseInt(last, 16);
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '100%',
  },
  media: {
    height: 140,
  },
  mediaHeader: {
    height: 240,
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightBold,
  },
  headingNormal: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: theme.typography.fontWeightRegular,
  },
  ...testimonialsSection,
  pageHeader: {
    position: 'relative',
    height: '100vh',
    maxHeight: '1600px',
    backgroundPosition: '50%',
    backgroundSize: 'cover',
    margin: '0',
    padding: '0',
    border: '0',
    display: 'flex',
    WebkitBoxAlign: 'center',
    MsFlexAlign: 'center',
    alignItems: 'center',
    '&:before': {
      background: 'rgba(' + hexToRgb('#000') + ', 0.5)',
    },
    '&:after,&:before': {
      position: 'absolute',
      zIndex: '1',
      width: '100%',
      height: '100%',
      display: 'block',
      left: '0',
      top: '0',
      content: "''",
    },
  },
  block: {
    minHeight: '100%',
    margin: '0 auto',

    padding: '10px 20px',
    // padding: "70px 0 30px",
    maxWidth: '360px',
    textAlign: 'center',
    // border for the card
    border: '1px solid #586a91',
    position: 'relative',
    backgroundColor: '#fff',
  },
  icon: {
    float: 'none',
    top: '-30px',
    left: '50%',
    transform: 'translateX(-50%)',
    // marginTop: "24px",
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '61px',
    height: '61px',
    position: 'absolute',
    backgroundColor: '#f2f5f9',
    borderRadius: '50%',
  },
  textBlock: {
    overflow: 'hidden',
  },

  mybutton: {
    borderRadius: '50%',
    overflow: 'hidden',
    pointerEvents: 'none',
    border: '1px solid #263d70',
    position: 'absolute',
    bottom: '-12px',
    left: '50%',
    transform: 'translateX(-50%)',
    padding: '0',
  },
  expandButton: {
    color: '#263d70',
    borderRadius: '50%',
    backgroundColor: '#f2f5f9',
  },
}));

const Users = (props) => {
  const { classes } = props;
  const expClasses = useStyles();
  return (
    // {/* PERSONS IN CHARGE */}
    <div className={classes.person} id="persons">
      <div className={classes.container}>
        <Grid container justify="center" spacing={8}>
          <Grid item xs={12} sm={12} md={10} className={`${classes.mlAuto} ${classes.mrAuto} ${classes.textCenter}`}>
            <h2 className={classes.title}>Користувачі та особисті кабінети ПК «ІІС «Соціальна громада»:</h2>
          </Grid>
          <Grid item xs={12} sm={12} md={5} className={`${classes.mlAuto} ${classes.mrAuto} ${classes.textCenter}`}>
            <div className={expClasses.block}>
              <div className={expClasses.icon}>
                <AdminPanel />
              </div>
              <div className={expClasses.textBlock}>
                <h4 className={classes.title}>Особистий кабінет - Старостинського округу/ЦНАП.</h4>
                <p className={classes.description}>Користувач - уповноважена особа Старостинського округу.</p>
                <p className={classes.description}>Користувач - уповноважена особа ЦНАП.</p>
              </div>
              {/* <IconButton className={expClasses.mybutton}>
                                <ExpandMoreIcon className={expClasses.expandButton} />
                            </IconButton> */}
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={5} className={`${classes.mlAuto} ${classes.mrAuto} ${classes.textCenter}`}>
            <div className={expClasses.block}>
              <div className={expClasses.icon}>
                <AdminPanel />
              </div>
              <div className={expClasses.textBlock}>
                <h4 className={classes.title}>Особистий кабінет уповноваженої особи ТГ.</h4>
                <p className={classes.description}>Користувач - уповноважена особа ТГ.</p>
              </div>
              {/* <IconButton className={expClasses.mybutton}>
                                <ExpandMoreIcon className={expClasses.expandButton} />
                            </IconButton> */}
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={5} className={`${classes.mlAuto} ${classes.mrAuto} ${classes.textCenter}`}>
            <div className={expClasses.block}>
              <div className={expClasses.icon}>
                <AdminPanel />
              </div>
              <div className={expClasses.textBlock}>
                <h4 className={classes.title}>
                  Особистий кабінет структурного підрозділу з питань соціального захисту населення (далі СПСЗН).
                </h4>
                <p className={classes.description}>Користувач - уповноважена особа СПСЗН.</p>
              </div>
              {/* <IconButton className={expClasses.mybutton}>
                                <ExpandMoreIcon className={expClasses.expandButton} />
                            </IconButton> */}
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={5} className={`${classes.mlAuto} ${classes.mrAuto} ${classes.textCenter}`}>
            <div className={expClasses.block}>
              <div className={expClasses.icon}>
                <AdminPanel />
              </div>
              <div className={expClasses.textBlock}>
                <h4 className={classes.title}>Особистий кабінет - обласної державної адміністрації (ОДА).</h4>
                <p className={classes.description}>Користувач - уповноважена особа ОДА.</p>
              </div>
              {/* <IconButton className={expClasses.mybutton}>
                                <ExpandMoreIcon className={expClasses.expandButton} />
                            </IconButton> */}
            </div>
          </Grid>

          {/* <Grid item xs={12} sm={12} md={10} className={`${classes.mlAuto} ${classes.mrAuto} ${
                        classes.textCenter
                        }`} >
                        
                        <List>
                            <ListItem>
                                <ListItemText primary="Особистий кабінет - Старостинського округу/ЦНАП."
                                secondary={
                                    <div>
                                      <div>Користувач - уповноважена особа Старостинського округу.</div>
                                      <div>Користувач - уповноважена особа ЦНАП.</div>
                                    </div>
                                  }
                                />
                            </ListItem>
                            <ListItem>
                                <ListItemText primary="Особистий кабінет уповноваженої особи ОТГ." secondary="Користувач - уповноважена особа ОТГ."/>
                            </ListItem>
                            <ListItem>
                                <ListItemText primary="Особистий кабінет структурного підрозділу з питань соціального захисту населення (далі СПСЗН)." secondary="Користувач - уповноважена особа СПСЗН." />
                            </ListItem>
                            <ListItem>
                                <ListItemText primary="Особистий кабінет - обласної державної адміністрації (ОДА)." secondary="Користувач - уповноважена особа ОДА." />
                            </ListItem>
                        </List>
                    </Grid> */}
        </Grid>
      </div>
    </div>
  );
};

export default withStyles(userStyles)(Users);
